import { useMutation } from '@tanstack/react-query';
import { authApi } from '../api/authApi';

export interface RevokeAllUserSessionsVars {
  userId: string;
  reason: string;
}

export const useRevokeAllUserSessions = () =>
  useMutation({
    mutationFn: ({ userId, reason }: RevokeAllUserSessionsVars) =>
      authApi.revokeAllUserSessions(userId, reason),
  });
